import React, { useState } from "react";
import { VisuallyHidden } from "react-aria";
import { t } from "ttag";

import { geocode } from "../../api/locations";
import { LatLng, fromGoogleLatLng } from "../../models";
import { Svg } from "../Svg";

import styles from "./UpdateLocationForm.module.scss";

export const UpdateLocationForm = (props: {
    onLocationUpdate: (
        point: LatLng,
        bounds?: google.maps.LatLngBounds,
    ) => void;
    onError: (error: string) => void;
}) => {
    const [inputText, setInputText] = useState("");

    const onSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        props.onError("");

        try {
            const results = await geocode({
                address: inputText,
            });
            const result = results[0];
            if (!result?.geometry?.location) {
                console.error("Result has no geometry info");
                return;
            }
            const point = fromGoogleLatLng(result.geometry.location);
            props.onLocationUpdate(point, result.geometry.bounds);
        } catch (error) {
            if (
                error !== null &&
                typeof error === "object" &&
                "code" in error
            ) {
                if (error.code === "ZERO_RESULTS") {
                    props.onError(
                        t`There are no results for what you entered.`,
                    );
                } else {
                    props.onError(
                        t`Something went wrong with what you entered. Try again, or refresh the page if problems persist.`,
                    );
                }
            } else console.error("UpdateLocationForm", error);
        }
    };

    return (
        <form onSubmit={onSubmit} className={styles.form}>
            <label>
                <VisuallyHidden>{t`Enter zip code`}</VisuallyHidden>
                <input
                    type="text"
                    placeholder={t`Enter zip code`}
                    autoComplete="postal-code"
                    value={inputText}
                    onChange={(e) => setInputText(e.target.value)}
                    className={styles.input}
                />
            </label>
            <button type="submit" className={styles.submit}>
                <Svg
                    name="search"
                    visuallyHiddenText={t`Search`}
                    className={styles.searchIcon}
                />
            </button>
        </form>
    );
};
